import React, { useState } from 'react';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Loader from '../../ReusableComp/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate,useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from 'react';
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import axios from "axios";
import { Col, Container, Modal, Row, Stack, Table } from "react-bootstrap";
import moment from "moment";
import {
    resetEventDetails,
    resetSubjectProfile,
    getAllWhoddClassification,
    getSubjectInformation,
    getReviewSubjDtls,
    getPmsStudyData,
    getNewPmsStudyData,
    getPmsNotifications
  } from "../../../Redux/actions/actions";
import {
    EVENT_STATUS_REVIEWED,
    base_url,
    EVENT_CLASSIFICATION_AESI,
    EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
    EVENT_CLASSIFICATION_GRADE_CTCAE,
    EVENT_CLASSIFICATION_OTHER,
    QUALITY_REVIEWER,
    SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW,
    SUBJECT_REVIEW_STATUS_REVIEWED,
    SUBJECT_REVIEW_STATUS_IN_PROGRESS,
    SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW,
    MEDDRA_ALLERGIES,
    MEDDRA_CONCURRENT_ILLNESS,
    MEDDRA_MEDICAL_HISTORY,
    WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS,
    WHODD_CONCOMITANT_MEDICATION,
    PMS_ADMIN
  } from "../../../utilities";
import SubjectReviewDetails from '../../Quality_Reviewer/SubjectReviewDetails';
import { GetMeddraBody, GetWhoDDBody } from '../../Quality_Reviewer/QrSubjectReview';

const PMSSubjectsReview = () => {

  const dispatch = useDispatch();
  const qrSubjectList = useSelector((state) => state.qrSubjectReviewList);
  const subjectCounts = useSelector((state) => state.qrSubjectsRelatedcounts);
  const qrSubjectInfoList = useSelector((state) => state.qrSubjectInfoList);


  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");
  let [loading_flag, Setloading_flag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  const location = useLocation();
  const navigate =useNavigate();


  
  useEffect(() => {
    if(location.state !== null ){
      handleSubjectData(location.state?.data);
      navigate({ state: null });
    }
    dispatch(getPmsStudyData())
    dispatch(getNewPmsStudyData())
    Setloading_flag(true);
    setFilteredData(qrSubjectList)
    if (qrSubjectList) {
      setTimeout(() => {
        Setloading_flag(false);
      }, 500);
    }


  }, [dispatch, localStorage.pi_id,qrSubjectList !== null,localStorage.study_id]);

  useEffect(() => {
    if (qrSubjectList) {
      setFilteredData(qrSubjectList)
    }
  },[qrSubjectList])

  const revSubjDtls = useSelector((state) => (state.revSubjDtls));
  const aeSubject = useSelector((state) => state.getAeOfSubj);
  const [qrStudyId, setQrStudyId] = useState("");
  const [loading, setLoading] = useState(false);


  function getStudieId(id) {
    setQrStudyId(id);
  }

  const dateOfReport = aeSubject?.date_of_report;
  const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
  const stepperData = [];
  const date = new Date(dateOfReport);
  while (date <= new Date(lastDayActiveFollowUp)) {
    stepperData.push({
      day: `Day${stepperData.length + 1}`,
      dateOfevent: date.toISOString().split("T")[0],
    });
    date.setDate(date.getDate() + 1);
  }
  function exportToExcel() {

    let excelArray = [];
    filteredData.forEach((i) => {

      switch (i.review_status) {
        case SUBJECT_REVIEW_STATUS_WAITING_FOR_REVIEW:
          i.review_status = "Waiting for review";
          break;
        case SUBJECT_REVIEW_STATUS_IN_PROGRESS:
          i.review_status = "In progress";
          break;
        case SUBJECT_REVIEW_STATUS_REVIEWED:
          i.review_status = "Reviewed";
          break;
        case SUBJECT_REVIEW_STATUS_SENT_BACK_FOR_REVIEW:
          i.review_status = "Sent back for review";
          break;
        default:
          break;
      }

      let xl_object = {
        "Subject ID": i.subject_code,
        "Site Name": i.site_name,
        "Sex": i.sex,
        "Status": i.review_status,
      };
      excelArray.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = excelArray;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Subjects_review_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const [open, setOpen] = React.useState(false);

  const dashboardCards = [
    {
      count: subjectCounts?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
      textColor: "white",
    },
  ];
 
  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = qrSubjectList?.filter((item) => {
      const { subject_code , site_name} = item;

      const formattedSubjectCode = subject_code?.toLowerCase();
      const formattedSiteName = site_name ? site_name.toLowerCase() : ""

      return (
        formattedSubjectCode.includes(searchText) ||
        formattedSiteName.includes(searchText)
      );
    });

    setFilteredData(filteredData);
  };



  const [subjData, setSubjData] = useState([]);
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [studyOption, setStudyOption] = useState();
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [isDivOpen, setIsDivOpen] = useState(false);
  const [reviewedDtls, setReviewedDtls] = useState(false);
 
  const [subjectID, setSubjectID] = useState('')
  const handleSubjectData = (data) => {

    setSubjectID(data.subject_id)
    dispatch(getSubjectInformation(data.subject_id))
    setLoading(true)
    if (inputValue) {
      setCurrentPage(2);
    }
    if (data.review_status === SUBJECT_REVIEW_STATUS_REVIEWED) {
      setReviewedDtls(true);

      dispatch(getReviewSubjDtls({
        "subject_id": data.subject_id
      }))


    }
    setSubjData(data)
    dispatch(getAllWhoddClassification())
    setTimeout(() => {
      setLoading(false);
    }, 200);
    if (data.review_status === 0) {
      axios
        .post(
          base_url + "quality-reviewer/update_subject_review_status_inprogress", { "subject_id": data.subject_id }
        )
        .then((res) => {
          setStudyDropdwn(true);
          setCurrentPage(2);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setStudyDropdwn(true);
      setCurrentPage(2);
    }
  };

  const [medraSelected, setIsMedraSelected] = useState(false)


  const [reviewerComment, setReviewerComment] = useState('')
  const handleReviewerComments = (e) => {
    let val = e.target.value;
    let value = val.trim()
    setReviewerComment(value || '')
    if (value !== '') { (setIsMedraSelected(true)) } else { setIsMedraSelected(false) }
  };
 
  const [alertMessage, setAlrtMessage] = useState('')
  const [btnId, setBtnId] = useState('')
   
  function handleReviewBtns(e) {
    let id = e.target.id;
    setBtnId(id)
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
      user_persona: PMS_ADMIN
    }))
    if (id === 'sendBack') {
      setAlrtMessage("Are you sure you want to send back for correction?")
      setOpen(true)
    } else if (id === 'closereview') {
      setAlrtMessage("Are you sure you want to close the review?")
      setOpen(true)
    }
    else {
      dispatch(resetEventDetails())
      dispatch(resetSubjectProfile())
      window.location.reload()
    }
  }

   

  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
 
  const [encodeBtn, setEncodeBtn] = useState(true)
 
  const [isBtn, setIsBtn] = useState(false)
 
 
 
  const [medicationDetails, setMedicationDetails] = useState([
    {
      "searchTerm": "",
      "whoDD_type": "",
      "medication_id":"",
      "current_idx": 0,
      "whoDDEncode": true,
      "whoddArray": [],
      "concmtntWhoDDArray": [],
    },
  ]);

  const [meddraDetails, setMeddraDetails] = useState([
    {
      "LLT": "",
      "PT": "",
      "searchTerm": "",
      "current_idx": 0,
      "meddra_type": null,
      "medDRAEncode": true,
      "meddraArray": [],
      "meddraMhArray": [],
      "meddraIllArray": [],

    },
  ]);
 
  const [medraModal, setMedraModal] = useState(false)
  const [whoDDModal, setWhoDDModal] = useState(false)
  const [typeId, setTypeId] = useState()

  const handleMeddraModal = (e) => {  
    if (e.target.id === 'allergies') {
      setTypeId(MEDDRA_ALLERGIES)
      if(meddraDetails[meddraDetails.length-1].meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_ALLERGIES}
    }
    if (e.target.id === 'medicalhistory') {
      setTypeId(MEDDRA_MEDICAL_HISTORY)
      if(meddraDetails[meddraDetails.length-1].meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_MEDICAL_HISTORY}
    }
    if (e.target.id === 'illness') {
      setTypeId(MEDDRA_CONCURRENT_ILLNESS)
      if(meddraDetails[meddraDetails.length-1].meddra_type ===null)
        {meddraDetails[meddraDetails.length-1].meddra_type = MEDDRA_CONCURRENT_ILLNESS}
    }
    setMedraModal(true)
  }
  const [showAddBtn, setShowAddBtn] = useState(false)
  const [medicationId, setMedicationId] = useState()
  
  const openwhoDDModal = (e) => {
    setMedicationId(e.target.getAttribute('value'))
    if (e.target.id === "concomitantWhodd") {
      setTypeId(WHODD_CONCOMITANT_MEDICATION)

      if (medicationDetails[medicationDetails.length-1].whoDD_type === ''||medicationDetails[medicationDetails.length-1].whoDD_type === undefined ) {
        medicationDetails[medicationDetails.length-1].whoDD_type = WHODD_CONCOMITANT_MEDICATION
        medicationDetails[medicationDetails.length-1].medication_id = e.target.getAttribute('value')
      }
      setShowAddBtn(false)
      setEncodeBtn(false)
    }
    if (e.target.id === "medusedlast3mnths") {
      setTypeId(WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS)
      if (medicationDetails[medicationDetails.length-1].whoDD_type === ''||medicationDetails[medicationDetails.length-1].whoDD_type === undefined) {
        medicationDetails[medicationDetails.length-1].whoDD_type = WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS
        medicationDetails[medicationDetails.length-1].medication_id = e.target.getAttribute('value')
      }
      setShowAddBtn(true)
      setEncodeBtn(false)
    }
    setWhoDDModal(true)
  }
  
  const onCloseMeddraModal = () => {
    setMedraModal(false)
  }

  const onCloseWhoDDModal = () => {
    setWhoDDModal(false) 
  }
  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeA.localeCompare(subjectCodeB);
    });
    setFilteredData(sortedData);
  };
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
    setFilteredData(sortedData);
  };
  let rolecode = localStorage.getItem('role_code')


 
    return (
        <div>
          <NavigationBar title={"Subjects Review"}  rolecode={rolecode}/>
          <div className="main_body">
          {currentPage === 1 && (
            <Container fluid className="pt-4 ">
              <Stack className="add_subject_stack ps-0">
                <div className="">
                  <Row className="row d-flex w-25">
                    {filteredData?.length > 0 && dashboardCards?.map((card, index) => {
                      return (
                        <Col key={index}>
                          <div
                            className="card-container"
                            style={{ backgroundColor: card.bgcolor }}
                          >
                            <div
                              className="content"
                              style={{ color: card.textColor }}
                            >
                              <span>{card.count}</span>
                              <img src={card.image} alt="" />
                            </div>
                            <div
                              className="desc"
                              style={{ color: card.textColor }}
                            >
                              {card.desc}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Stack>

              {qrSubjectList && qrSubjectList?.length > 0 ? (
                <Container fluid className="pitable_container mt-2  ">
                  <Row className='searchbar'>
                    <Col className='searchFiled gap-3'>
                      <label htmlFor="" />
                      <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID or Site Name' onChange={handleSearchData} />
                      <div className=" ">
                        <button
                          className="btn btn-success "
                          onClick={exportToExcel}
                          style={{height:"42px"}}
                        >
                          Download XLS
                          <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                        </button>
                      </div>

                    </Col>
                  </Row>

                  <div>
                    {loading_flag ? (
                      <div className=''>
                        <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

                        />
                      </div>

                    ) : (
                      <div className="table-scroll-container " style={{ border: "1px solid #E1E5E7 " }}>
                        {filteredData?.length > 0 ?
                          <Table bordered size="sm" className="pitable mb-0">
                            <thead className='sticky_table_header'>
                              <tr>
                                <th> S.No</th>
                                <th className="sticky-header">
                              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                        </th>

                                <th style={{ minWidth: "145px" }}>
                                  Sex
                                  
                                </th>
                                <th>
                                  Site
                                  
                                </th>
                                <th>
                                  Events
                                  
                                </th>
                                <th>
                                  Quality Reviewer Name
                                  
                                </th>
                                <th>Reviewed By Quality Reviewer</th>
                              </tr>
                            </thead>

                            <tbody className="tableBodyScroll ">
                              {filteredData?.map((i, index) => {
                                return (
                                  <tr key={index} className="text_left_table">
                                    <td className='text_right_sno'> {index + 1} </td>
                                    <td>{i.subject_code ? i.subject_code :"-"}</td>
                                    <td>{i.sex ? i.sex :"-"}</td>
                                    {/* <td>{i.site_name}</td> */}
                                    <td><span title={i.site_name}>{i.site_name ? i.site_name :"-"}</span></td>
                                    <td>{i.events_reported ? (i.events_reported  + i.sae_count):"-"}</td>
                                    <td>{i.review_status === SUBJECT_REVIEW_STATUS_REVIEWED ? i.qr_name : "-"}</td>

                                    <td className="viewbtnstyl">
                                      
                                      {i.review_status === SUBJECT_REVIEW_STATUS_REVIEWED ? (
                                        <button
                                          className="green_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          Reviewed
                                        </button>
                                      ) : "No"}
                                       
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          :
                          <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                        }
                      </div>
                    )}
                  </div>
                </Container>
              ) : qrSubjectList === null ? <div className=''>
                    <img
                        className="atrium_loader"
                        src="/images/circle-effect-loading.gif"
                        alt="Loader"

                    />
                  </div> :   (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <img src="./images/no_subjects.svg" alt="Telephone" />
                    <h5> No Subjects Reviews Found </h5>
                  </div>
                </>
              )}
            </Container>
          )}

          {currentPage === 2 && (
            <Container fluid className="p-0 page_two_styl">
              <div className="">
                <div className="mb-5 pb-5 pt-3 px-3 gap-3 d-grid">
                  <SubjectReviewDetails/>

                  <div className='row d-flex justify-content-center justify-content-md-between gap-3 mt-2'>
                    <div className="card viewCardStyl col" >
                      <div className="card-header cardHeading">
                        <h6>Concomitant Medication</h6>
                      </div>
                      <div className=" cardBody">
                        {qrSubjectInfoList?.concomitantMedication !== null && qrSubjectInfoList?.concomitantMedication[0]?.concomitant_medication_id !== null ?
                          <div className=" body Concon_medication_main w-100">
                            <table className="table Concon_medication">
                              <thead className='text-center'>
                                <tr>
                                  <th scope="col">Medication</th>
                                  <th scope="col">Batch Number</th>
                                  <th scope="col">Manufacturer</th>
                                  <th scope="col">Route/Site</th>
                                  <th scope="col">Dosage</th>
                                  <th scope="col">Frequency</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {revSubjDtls ?revSubjDtls?.concomitantMedication?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication ? i.medication :"-"}</td>
                                      <td>{i.medication_batch_number ? i.medication_batch_number :"-"}</td>
                                      <td>{i.medication_manufacturer ? i.medication_manufacturer :"-"}</td>
                                      <td>{i.medication_route_site ? i.medication_route_site :"-"}</td>
                                      <td>{i.medication_dosage ? i.medication_dosage :"-"}</td>
                                       <td>{i.medication_frequency ? i.medication_frequency :"-"}</td>  
                                      <td className="medication_3_weeks" >
                                      <button className="white_btn py-1 px-2" id="concomitantWhodd" value={i.concomitant_medication_id} onClick={openwhoDDModal}
                                      disabled={!(revSubjDtls?.whoddDrugs?.some(j => j.medication_type==WHODD_CONCOMITANT_MEDICATION && j.medication_id === i.concomitant_medication_id))&& revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
                                      >
                                      
                                      WHODD{revSubjDtls&& revSubjDtls.whoddDrugs?.find((data) => data.medication_id === i.concomitant_medication_id)?<i className="fa-solid fa-check text-success"/>:''}
                                      </button>
                                      </td>
                                    </tr>
                                  );
                                }) : qrSubjectInfoList?.concomitantMedication?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication ? i.medication :"-"}</td>
                                      <td>{i.medication_batch_number ? i.medication_batch_number :"-"}</td>
                                      <td>{i.medication_manufacturer ? i.medication_manufacturer :"-"}</td>
                                      <td>{i.medication_route_site ? i.medication_route_site :"-"}</td>
                                      <td className="medication_3_weeks"><button className="white_btn py-1 px-2" id="concomitantWhodd" value={i.concomitant_medication_id} onClick={openwhoDDModal}>WHODD</button></td>
                                    </tr>
                                  );
                                })}            
                              </tbody>
                            </table>
                          </div>
                          :
                          <div className="concomitantMsg">
                            <p>No Concomitant Medication</p>
                          </div>}
                      </div>
                    </div>
                  
                  </div>


                   <div className='d-flex justify-content-center justify-content-md-between gap-3 mt-2 w-100 p-0'>
                   <div className="card viewCardStyl col" >
                      <div className="card-header cardHeading">
                        <h6>Past Health History</h6>
                      </div>
                      <div className="  table-responsive body">
                        <table className="table card_columns_styl border-0">
                          <tbody>
                            {qrSubjectInfoList?.allergies !== null && <tr>
                              <td>Allergies</td>
                              <td>{qrSubjectInfoList?.allergies}</td>
                              <td ><button id='allergies' className="white_btn py-1" onClick={(e) => handleMeddraModal(e)} 
                              style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}}
                              disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 1))}
                              >MedDRA {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 1)                             
                              
                              ?<i className="fa-solid fa-check text-success"/>:''}</button></td>
                            </tr>}
                            {qrSubjectInfoList?.medical_history !== null && <tr>
                              <td>Medical History</td>
                              <td>{qrSubjectInfoList?.medical_history}</td>
                              <td ><button id='medicalhistory' className="white_btn py-1" onClick={(e) => handleMeddraModal(e)}
                              style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}}
                              disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 2))}
                              >MedDRA {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 2)?<i className="fa-solid fa-check text-success"/>:''}</button></td>
                            </tr>}
                            {qrSubjectInfoList?.concurrent_illness !== null && <tr>
                              <td>Illness</td>
                              <td>{qrSubjectInfoList?.concurrent_illness}</td>
                              <td ><button id='illness' className="white_btn py-1" onClick={(e) => handleMeddraModal(e)}
                              style={{borderColor:revSubjDtls?.meddraObjects?.length>0?"green":''}}
                              disabled={!(revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 3))}
                              >MedDRA {revSubjDtls?.meddraObjects?.some(i => i.meddra_type == 3)?<i className="fa-solid fa-check text-success"/>:''}</button></td>
                            </tr>}
                            {/* {qrSubjectInfoList?.medication_used_in_last_3weeks !== null && <tr>
                              <td>Medication used in last 3 weeks</td>
                              <td>{qrSubjectInfoList?.medication_used_in_last_3weeks}</td>
                              <td ><button id='medusedlast3mnths' className="white_btn py-1" value={subjectID} 
                              disabled={!(revSubjDtls?.whoddObjects?.some(i => i.medication_type==1)) || revSubjDtls?.whoddObjects ==null}
                               onClick={openwhoDDModal}
                              style={{borderColor:revSubjDtls?.whoddObjects?.length>0?"green":''}}
                              >WHODD {revSubjDtls?.whoddObjects?.some(i => i.medication_type==1)?<i className="fa-solid fa-check text-success"/>:''}</button></td>
                            </tr>} */}
                          </tbody>

                        </table>
                      </div>
                      <div className="d-flex justify-content-center">
                        {qrSubjectInfoList?.allergies === null &&
                          qrSubjectInfoList?.medical_history === null &&
                          qrSubjectInfoList?.concurrent_illness === null &&
                          <div className="mt-5 ">
                            <p>No Past Health History</p>
                          </div>
                        }
                      </div>
                    </div>

                    <div className="card viewCardStyl col" >
                      <div className="card-header cardHeading">
                        <h6>Any medication used in last 3 weeks</h6>
                      </div>
                      <div className=" cardBody">
                        {qrSubjectInfoList?.medicationUsedInLast3Weeks?.subject_medication_used_in_last_3weeks_id !== null ?
                          <div className=" body Concon_medication_main w-100">
                            <table className="table Concon_medication">
                              <thead className='text-center'>
                                <tr>
                                <th scope="col">Medication</th>
                                  <th scope="col">Route</th>
                                  <th scope="col">Dosage</th>
                                 <th scope="col">Frequency</th>
                                 <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {revSubjDtls ?revSubjDtls?.medicationUsedInLast3Weeks?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication_name ? i.medication_name :"-"}</td>
                                      <td>{i.medication_route ? i.medication_route :"-"}</td>
                                       <td>{i.dosage ? i.dosage :"-"}</td>
                                       <td>{i.frequency ? i.frequency :"-"}</td>  
                                      <td className="medication_3_weeks" >
                                        <button className="white_btn py-1 px-2" id="medusedlast3mnths" value={i.subject_medication_used_in_last_3weeks_id} onClick={openwhoDDModal}
                                      disabled={!(revSubjDtls?.whoddDrugs?.some(j => j.medication_type==WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS && j.medication_id === i.subject_medication_used_in_last_3weeks_id))&& revSubjDtls?.review_status==SUBJECT_REVIEW_STATUS_REVIEWED}
                                      >
                                      
                                      WHODD{revSubjDtls&& revSubjDtls.whoddDrugs?.find((data) => data.medication_id === i.subject_medication_used_in_last_3weeks_id)?<i className="fa-solid fa-check text-success"/>:''}</button>
                                      </td>
                                    </tr>
                                  );
                                }) : qrSubjectInfoList?.medUsedInLast3Weeks?.map((i, index) => {
                                  return (
                                    <tr key={index} className='text-center'>
                                      <td>{i.medication_name ? i.medication_name :"-"}</td>
                                      <td>{i.medication_route ? i.medication_route :"-"}</td>
                                       <td>{i.dosage ? i.dosage :"-"}</td>
                                       <td>{i.frequency ? i.frequency :"-"}</td> 
                                      <td className="medication_3_weeks"><button className="white_btn py-1 px-2" id="medusedlast3mnths" value={i.subject_medication_used_in_last_3weeks_id} onClick={openwhoDDModal}>WHODD</button></td>
                                    </tr>
                                  );
                                })}            
                              </tbody>
                            </table>
                          </div>
                          :
                          <div className="concomitantMsg">
                            <p>No  Medication Used in last 3 weeks</p>
                          </div>}
                      </div>
                    </div>






                   </div>






                  <div className=''>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "20px",
                        width: "100%",
                        alignItems: "start",
                      }}
                    >
                      <label htmlFor="add your comments" className="fw-bold fs-6">
                        Quality Reviewer Comment<span className="text-danger">{reviewedDtls?'': "*"}</span>
                      </label>
                      {!revSubjDtls?.comments &&   <textarea
                        id="add_your_comments"
                        style={{
                          width: "100%",
                          minHeight: "100px",
                          borderColor: "#E1E5E7",
                          borderRadius: "8px",
                          padding: "10px"
                        }}
                        disabled={reviewedDtls}
                        placeholder={`${revSubjDtls ? revSubjDtls?.comments ===undefined ? '-':revSubjDtls?.comments : "type here"}`}
                        onChange={handleReviewerComments}
                      />}
                    </div>
                    <div className="d-flex gap-3 flex-column">
                      {
                        revSubjDtls?.comments?.map(i =>{
                          return(
                          <div className="p-3 border rounded">
                      
                          <p className="mb-1">Comment : {i.comment}</p>
                          <p className="mb-1">At : {i.createdAt}</p>
                          </div>
                      
                        )})
                      }
                    </div>
                  </div>
                </div>
                <div className="registrationStepsFooter" >
                  {subjData.review_status === SUBJECT_REVIEW_STATUS_REVIEWED ?
                    <button className="white_btn white_btn_back px-3" onClick={() => {
                      setCurrentPage(1);
                    }}>
                      Back
                    </button>
                    : <div className="d-flex gap-2">
                      <button className="white_btn white_btn_back px-3" id={'cancel'} onClick={handleReviewBtns}>
                        Back
                      </button>
                      <button
                        id={'sendBack'}
                        className="red_btn"
                        onClick={handleReviewBtns}
                        disabled={reviewerComment === ''}
                      >
                        Send Back for Correction
                      </button>

                      <button
                        id={'closereview'}
                        className="green_btn"
                        onClick={handleReviewBtns}
                        disabled={!(medraSelected)}

                      >
                        Close Review
                      </button>
                    </div>}
                </div>
              </div>
            </Container>
          )}
        </div>
        {loading && <Loader />}
        <Modal
        size="lg"
        show={medraModal}
        onHide={
          onCloseMeddraModal

        }
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            MedDRA
          </Modal.Title>
        </Modal.Header>
        {revSubjDtls &&
        
          <GetMeddraBody revSubjDtls={revSubjDtls} typeId={typeId}/>
        }
        
        
      </Modal>

      <Modal
        size="lg"
        show={whoDDModal}
        onHide={onCloseWhoDDModal}
        backdrop={"static"}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          WHODD
          </Modal.Title>
        </Modal.Header>
        {revSubjDtls && 
          <GetWhoDDBody revSubjDtls={revSubjDtls} typeId={typeId} medicationId={medicationId} reviewedDtls={reviewedDtls}/>
        }
      </Modal>
        </div>
    );
};

export default PMSSubjectsReview;